import { useEffect, useState } from 'react'
import { useBooks } from './useBooks'
import { useSchoolClass } from './useSchoolClass'
import { useSchool } from './useSchool'

const useBooksWithRelatedSchoolGroups = (id) => {
  const { books, isLoading: isLoadingBooks } = useBooks()
  const { schoolClass, isLoading: isLoadingSchoolClass } = useSchoolClass(id)
  const { school, isLoading: isLoadingSchool } = useSchool(schoolClass?.school?.id)
  const [relatedSchoolGroups, setRelatedSchoolGroups] = useState()
  const [booksWithRelatedSchoolGroups, setBooksWithRelatedSchoolGroups] = useState()

  useEffect(() => {
    if (school && schoolClass && !isLoadingBooks && books?.length > 0) {
      const studentIds = schoolClass.students.map(student => student.id)
      const groups = school?.schoolGroups?.filter(sg => sg.students.some(student => studentIds.includes(student.id)))
      const uniqueGroups = groups.reduce((acc, group) => acc.every(unique => unique.id !== group.id) ? [...acc, group] : acc, [])
      setRelatedSchoolGroups(uniqueGroups)

      const booksWithGroups = uniqueGroups
        .flatMap((group) =>
          group.books
            .map(({ id, pivot }) => ({ ...(books.find(book => book.id === id)), pivot }))
            .map((book) => ({
              ...book,
              schoolGroups: uniqueGroups.filter((schoolGroup) =>
                schoolGroup.books.some(({ id }) => id === book.id)
              ),
            }))
        )
        .reduce(
          (acc, book) =>
            acc.every((unique) => unique.id !== book.id) ? [...acc, book] : acc,
          []
        )

      setBooksWithRelatedSchoolGroups([...schoolClass.books, ...booksWithGroups])
    }
  }, [school, schoolClass, isLoadingBooks, books.length])

  return {
    booksWithRelatedSchoolGroups,
    relatedSchoolGroups,
    isLoading: isLoadingBooks || isLoadingSchool || isLoadingSchoolClass,
  }
}

export { useBooksWithRelatedSchoolGroups }
